<section class="pt-navigation-context">
    <dls-tabs class="pt-secondary-navigation">
      <a routerLink="/patient-search/pms"
         routerLinkActive="pt-selected"
         [routerLinkActiveOptions]="{ exact: true }">
        <span>Lazy Loading</span>
        <span>Patient</span>
      </a>
      <a *ngIf="isAggregator" routerLink="/patient-search/pms-aggregator" routerLinkActive="pt-selected">
        <span>Aggregator</span>
      </a>
    </dls-tabs>
    <div class="toggle-row">
      <span class="toggle-label">Lazy Loading</span>
      <span class="toggle-label">Patient</span>
      <label class="switch">
        <input type="checkbox" [checked]="isAggregator" (change)="onToggle($event)">
        <span class="slider"></span>
      </label>
      <span class="toggle-label">Aggregator</span>
    </div>
</section>
<router-outlet></router-outlet>
